import React, { createContext, useEffect, useRef, useState } from 'react';
import api from '../services/api';

export const SalleContext = createContext({});

function SalleProvider({ children }) {
    const [animation, setAnimation] = useState(false)
    const [salle, setSalle] = useState([])
    const [client, setClient] = useState([])
    const [products, setProducts] = useState([])
    const [product, setProduct] = useState([])
    const [typeTable, setTypeTable] = useState()
    const [modalSalle, setModalSalle] = useState(false)
    const [salleStatus, setSalleStatus] = useState()

    const getById = async (id) => {
        setAnimation(true)
        const response = await api.get(`panel/get/info/request/${id}`)
        if (response.status == 200) {
            getClientById(response.data[0].user_id)
            getProductById(response.data[0].product_id)
            setSalle(response.data[0])
            setProducts(response.data)

            setTimeout(() => {
                setAnimation(false)
            }, [1500])

        }
    }
    const getClientById = async (id) => {
        const response = await api.get(`panel/get/client/by/id/${id}`)
        if (response.status == 200) {
            setClient(response.data[0])
        }
    }
    const getProductById = async (id) => {
        const response = await api.get(`client/get/product/by/id/${id}`)
        if (response.status == 200) {
            setProduct(response.data.product)
        }
    }



    return (
        <SalleContext.Provider value={{
            getById,
            getClientById,
            getProductById,
            setTypeTable,
            typeTable,
            product,
            client,
            salle,
            products,
            animation,
            setModalSalle,
            modalSalle,
            setSalleStatus,
            salleStatus
        }}>
            {children}
        </SalleContext.Provider>
    );
}

export default SalleProvider;
